import { initializeApp } from 'firebase/app';

// Firebase configuration for Rez Holiday project
const firebaseConfig = {
  apiKey: 'AIzaSyBKfLrxAt6WUh4wAlL33mpu0_aVRRLaA94',
  authDomain: 'rez-holiday.firebaseapp.com',
  projectId: 'rez-holiday',
  storageBucket: 'rez-holiday.firebasestorage.app',
  messagingSenderId: '1054874885788',
  appId: '1:1054874885788:web:b64a5b1f7c7b04e8601759',
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

export default firebaseApp;

